import { createAliasResolver, createMongoAbility } from '@casl/ability';
import { AbilityRule } from './ability.types';

export const resolveAction = createAliasResolver({
  crud: ['create', 'read', 'update', 'delete'],
});

const getAbility = (rules: AbilityRule[]) => {
  return createMongoAbility(rules, { resolveAction });
};

export default getAbility;
